import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { updateSimpleStepSection } from "../../api/apiSimpleStepSection";
import parseError from "../../utils/parseError";

export const useUpdateSimpleStepSection = () => {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || "en").startsWith("ar");

    const mutation = useMutation({
        mutationFn: (data) => updateSimpleStepSection(data),
        onSuccess: (response) => {
            queryClient.invalidateQueries({ queryKey: ["simple-step-section"] });
            toast.success(
                response?.message ||
                (isArabic ? "تم تحديث بيانات الخطوات البسيطة" : "Simple Step Section updated")
            );
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || (isArabic ? "تعذر التحديث" : "Failed to update"));
        },
    });

    return mutation;
};
